import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const namespaced = true

const defaultMeta =  {
  current_page: 1,
  desc: false,
  last_page: null,
  order: 'created_at',
  per_page: null,
  search: null,
  total: null
}

const defaultView = 'active'
const inactiveView = 'suspended'
const archivedView = 'banned'

const state = {
  _defaultView: defaultView,
  _archivedView: archivedView,
  _inactiveView: inactiveView,
  views: {
    [defaultView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        active: true,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [inactiveView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: false,
        active: false,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    },
    [archivedView]: {
      index: {},
      ids: [],
      fetching: false,
      meta: {
        archived: true,
        active: null,
        ...JSON.parse(JSON.stringify(defaultMeta))
      }
    }
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/users/index.js